// extracted by mini-css-extract-plugin
module.exports = {"top_deals":"styles_top_deals__1NoMa","card":"styles_card__yWORN","card__image":"styles_card__image__R27W_","category_card__content":"styles_category_card__content__6viLk"};